<div
	class="kpa-spinner-wrap"
	*ngIf="loading">
	<kendo-dialog
		*ngIf="opened"
		(close)="close()">
		<app-kpa-inside-spinner></app-kpa-inside-spinner>
	</kendo-dialog>
</div>
